const gradientModelTypeToTraitType = {
  'linear-gradient': 'linear',
  'radial-gradient': 'radial',
};

const getGradientTraitTypeByGradientModelType = (gradientModelType) =>
  gradientModelTypeToTraitType[gradientModelType] || gradientModelType;

export default getGradientTraitTypeByGradientModelType;
